(function () {
    'use strict';

    angular
        .module("skillsApp")
        .filter('dateOfExpiryWhenApproved', dateOfExpiryWhenApproved);

    function dateOfExpiryWhenApproved($filter, $translate) {
        var dateFilter = $filter('date');

        return function (value, scope) {
            var item = scope;

            if (scope.row) {
                // scope.row is for use in ui-grid, if that's not set assume 'scope' is the user quality
                item = scope.row.entity;

                if (!value)
                    return "";
            }

            if (item.notNecessary)
                return $translate.instant('inapplicable');

            if (item.dateOfExpiry) {
                return dateFilter(item.dateOfExpiry, 'dd-MM-yyyy');
            }
            
            return $translate.instant('not_yet_finalized');
        };
    }
})();
